import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
//import { Helmet } from "react-helmet";

import Box from "@material-ui/core/Box";

const ContentVideo = ({ videoId }) => {
	const classes = useStyles("Content");

	// Define the base URL for YouTube embeds
	const youtubeEmbedUrl = `https://www.youtube.com/embed/${videoId}`;

	return (
		<Box my={10}>
			<div
				className="video-responsive"
				style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}
			>
				<iframe
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						width: "100%",
						height: "100%",
					}}
					src={youtubeEmbedUrl}
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
					title="Embedded YouTube Video"
				/>
			</div>
		</Box>
	);
};

ContentVideo.propTypes = {
	videoId: PropTypes.string.isRequired, // Ensures that videoId is a required prop
};

export default ContentVideo;

// import React, { useEffect } from "react";
// import PropTypes from "prop-types";
// import useStyles from "@hooks/useStyles";
// import { Helmet } from "react-helmet";

// import Box from "@material-ui/core/Box";
// import LazyLoad from "@custom/LazyLoad";

// const ContentVideo = ({ videoId }) => {
// 	const classes = useStyles("Content");

// 	const serviceUrl = "/math-tutors";

// 	useEffect(() => {
// 		window._wq = window._wq || [];
// 		window._wq.push({
// 			id: videoId,
// 			options: {
// 				plugin: {
// 					"postRoll-v1": {
// 						on: "true",
// 						rewatch: "true",
// 						raw: `<div className="video-postroll"><div className="post-title">You're on a roll. Keep up the good work!</div><div className="video-buttons"><a href="/${serviceUrl}" target="_blank" className="btn btn-blue btn-bold btn-xl btn-text" rel="noreferrer">Find a Tutor</a></div></div>`,
// 					},
// 				},
// 			},
// 		});
// 	}, []);
// 	return (
// 		<Box my={10}>
// 			<Helmet>
// 				<script
// 					src={`https://fast.wistia.com/embed/medias/${videoId}.jsonp`}
// 					async
// 				/>
// 				<script src="https://fast.wistia.com/assets/external/E-v1.js" async />
// 			</Helmet>

// 			<div
// 				className="wistia_responsive_padding"
// 				style={{ padding: "56.25% 0 0 0", position: "relative" }}
// 			>
// 				<div
// 					className="wistia_responsive_wrapper"
// 					style={{
// 						height: "100%",
// 						left: 0,
// 						position: "absolute",
// 						top: 0,
// 						width: "100%",
// 					}}
// 				>
// 					<div
// 						className={`wistia_embed wistia_async_${videoId} videoFoam=true`}
// 						style={{
// 							height: "100%",
// 							position: "relative",
// 							width: "100%",
// 						}}
// 					>
// 						<div
// 							className="wistia_swatch"
// 							style={{
// 								height: "100%",
// 								left: 0,
// 								opacity: 0,
// 								overflow: "hidden",
// 								position: "absolute",
// 								top: 0,
// 								transition: "opacity 200ms;width:100%",
// 							}}
// 						>
// 							<LazyLoad>
// 								<img
// 									src={`https://fast.wistia.com/embed/medias/${videoId}/swatch`}
// 									style={{
// 										filter: "blur(5px)",
// 										height: "100%",
// 										objectFit: "contain",
// 										width: "100%",
// 									}}
// 									alt=""
// 									onLoad={(e) => {
// 										//e.parentNode.style.opacity = 1;
// 									}}
// 								/>
// 							</LazyLoad>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 		</Box>
// 	);
// };

// ContentVideo.propTypes = {};
// export default ContentVideo;
